module.exports = __webpack_public_path__ + "static/media/YF67_0.04483acf.jpg";